import { Component, OnInit } from '@angular/core';
//import { version } from '../../../../../package.json';


@Component({
    selector: 'app-footer-one',
    templateUrl: './footer-one.component.html',
    styleUrls: ['./footer-one.component.scss'],
    standalone: false
})
export class FooterOneComponent implements OnInit {

  version = 1.6;

  constructor() { }

  ngOnInit() {
  }

}
